import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchPublicHealthIssuesArgs } from '../api/types/user.types';

import { fetchPublicHealthIssues } from '../api/users.api';

export const healthIssuesQueryKeys = createQueryKeys('healthIssues', {
  fetchInfiniteHealthIssues: ({
    filters,
    locale,
  }: FetchPublicHealthIssuesArgs) => ({
    queryFn: (context) =>
      fetchPublicHealthIssues({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        locale,
      }),
    queryKey: [filters],
  }),
});
